import {Model} from './model';
import {Contract} from "./contract";
import {Testbed} from "./testbed";
import {User} from "./user";

export class Company extends Model {
  id?: number;
  companyName?: string;
  companyEmail?: string;
  companyAddress?: string;
  contact1email?: string;
  contact2email?: string;
  contact1phone?: string;
  contact2phone?: string;
  contact1role?: string;
  contact2role?: string;

  customers?: User[];

  contracts?: Contract[];
  testbeds?: Testbed[];
}
